import { useMediaQuery } from '@mui/material';

// True when a finger is the main pointer. This is the question "does this
// device hover?", which is not the same as "is the window narrow": a tablet in
// landscape is wide and has fingers, a narrow desktop window has a mouse.
export const TOUCH_QUERY = '(pointer: coarse)';

export function useTouchInput(): boolean {
    // noSsr: read matchMedia on the first render, so the first paint is the
    // right one.
    return useMediaQuery(TOUCH_QUERY, { noSsr: true });
}
